import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import fill from 'lodash/fill';
import map from 'lodash/map';
export default {
  name: 'MdmPagination',
  props: {
    pageSize: {
      type: Number,
      default: 40
    },
    total: {
      type: Number,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      show: ''
    };
  },
  computed: {
    pagination: function pagination() {
      var a = fill(Array(Math.ceil(this.total / this.pageSize)), 1);
      return map(a, function (x, y) {
        return y + 1;
      });
    }
  },
  mounted: function mounted() {
    this.show = 'd-none';
  }
};